<template>
    <MenuItem class="md:hidden text-sm">
      <button class="" @click="openTheme">{{ t('layouts.user_bar.themes') }}</button>
    </MenuItem>
    <MenuItem class="md:hidden text-sm">
      <button class="" @click="openAvatar">{{ t('layouts.user_bar.avatars') }}</button>
    </MenuItem>
    <MenuItem v-if="authorizedAsAdmin || authorizedAsSiteAdmin || authorizedAsMultiSiteViewer" class="md:hidden text-sm">
      <a :href="Routes.site_admin_root_path()" class="block text-base" :class="isActive('/site_admin') ? 'text-accent underline' : 'text-primary'">
        {{ t('common.admin') }}
      </a>
    </MenuItem>
    <MenuItem v-if="authorizedAsCustomerAdmin" class="md:hidden text-sm">
      <a :href="Routes.customers_url()" class="block text-base" :class="isActive('/sites') ? 'text-accent underline' : 'text-primary'">
        {{ t('layouts.user_bar.customers') }}
      </a>
    </MenuItem>
    <MenuItem class="md:hidden text-sm">
      <a :href="Routes.edit_user_url()" class="block text-base" :class="isActive('/user/edit') ? 'text-accent underline' : 'text-primary'">
        {{ t('layouts.user_bar.account_settings') }}
      </a>
    </MenuItem>
    <MenuItem id="logout-mobile" class="md:hidden text-sm">
      <RailsForm :action="Routes.logout_path()" method="delete">
        <button type="submit" data-test="logout-button" :data-logout-path="Routes.logout_path()" class="block ">
          {{ t('common.logout') }}
        </button>
      </RailsForm>
    </MenuItem>
</template>

<script setup>
import { openModal } from 'vue_features/shared/composables/use_global_modals'
import { useCurrentUserStore } from 'vue_features/shared/store/composables'
import Routes from 'routes'
import merge from 'lodash/merge'
import { common, layouts } from 'vue_features/shared/i18n'
import { namespaceLocaleObj } from 'vue_features/shared/helpers/i18n_helper'
import { useI18n } from 'vue-i18n'
import { RailsForm } from 'vue_features/shared/components/forms'
import MenuItem from 'vue_features/shared/components/ui/MenuItem.vue'

const { authorizedAsAdmin, authorizedAsSiteAdmin, authorizedAsCustomerAdmin, authorizedAsMultiSiteViewer } = useCurrentUserStore()
const currentPath = window.location.pathname

function isActive(path) {
  return currentPath.startsWith(path)
}
const messages = merge(
  {},
  namespaceLocaleObj(common, 'common', { only: ['admin', 'logout'] }),
  namespaceLocaleObj(layouts, 'layouts', { only: ['user_bar'] }),
)
const { t } = useI18n({ messages })
const openTheme = () => {
  openModal('ThemeModal')
}
const openAvatar = () => {
  openModal('AvatarModal')
}
</script>
